if (!customElements.get('multicolumn-slider')) {
  class MulticolumnSlider extends HTMLElement {
    constructor() {
      super();
    
      this.sliderSettings = {
        slidesPerView: 1,
        pagination: {
          el: this.querySelector('.swiper-pagination')
        }
      };
    }

    initSlider() {
      this.swiper = new Swiper(this.container, this.sliderSettings);
    }

    connectedCallback() {
      this.container = this.querySelector('.swiper');
      if(!this.container) return;

      this.initSlider();
    }
  }

  customElements.define('multicolumn-slider', MulticolumnSlider);
}